import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import NotificationBar from "@components/NotificationBar/index";
import BreakupBox from "@components/Audit/breakup-box";
import "./uploaded-details.scss";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  VendorCheckpointAssignDocument,
  exportAuditComplete,
  getVendorFilterLegislation,
  getVendorFilterLocation,
  submitVendorCheckpointTasks,
  vendorCheckpointDetailDashboardInfo,
  vendorCheckpointDocumentlist,
  vendorDeleteCheckpointLocationCommnets,
  vendorDeleteCheckpointLocationFile,
  vendorGetCheckpointInfoBySpecificLocation,
  vendorGetCheckpointLocationDashboardInfo,
} from "@services/checkpoint.service";
import qs from "query-string";
import moment from "moment";
import { getValue } from "@utils/lodash";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import PaginationPage from "@components/pagination/pagination";
import Header from "@components/common/Header";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalBody,
} from "reactstrap";
import CommentsModal from "./Modal/comments";
import { useParams } from "react-router-dom";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import UploadModal from "./Modal/upload";
import InputField from "@_common/InputRuleFeild";
import { formatText } from "@_common/text-helper";
import { handleDownloadOnClick } from "@_common/downloadfile";
import { handleS3FileDownloadOnClick } from "@_common/s3-downloadfile";
import ReactTooltip from "react-tooltip";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NavigationBarAudit from "@components/NotificationBarAudit";
import SearchableDropdownSelect from "@_common/SearchableDropdown";
import { convertDateAsString, currentDate } from "@_common/date-helpers";
import React from "react";
import Marquee from "react-fast-marquee";

interface ICheckPointDetailsProps {}

export const CheckPointDetails: React.FunctionComponent<
  ICheckPointDetailsProps
> = (props) => {
  let navigate = useNavigate();
  let mainParams = useParams();

  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = useState(false);
  const [locations, setLocations] = useState([]);

  const [filteredLocations, setFilteredLocations] = useState([]);
  const [filteredLegislation, setFilteredLegislation] = useState([]);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0) {
      getData();
      getDashboardInfo();
      setDate(new Date());
      getFilterLegislations("", "");
      getUnAssignedDocumentList();
    }
    // getFilterLocations();
  }, []);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0) {
      getData();
      getDashboardInfo();
      getUnAssignedDocumentList();

      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }
      if (params.legislation_id) {
        getFilterLegislations(params.legislation_id, "");
      } else {
        getFilterLegislations("", "");
      }
    }
  }, [window.location.href]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getFilterLocations = async () => {
    try {
      let resp = await getVendorFilterLocation();
      if (resp) {
        setFilteredLocations(
          getValue(resp, `data`, []).map((item: any) => ({
            ...item,
            value: getValue(item, `location_name`, ""),
            label: getValue(item, `location_name`, ""),
          }))
        );
      }
    } catch (error) {}
  };

  const getFilterLegislations = async (id: string, value: string) => {
    let payload: any = {
      legislation_id: id,
      search_text: value,
      page_no: 1,
      page_size: 10,
    };
    let queryRequest = QueryRequestHelper(payload);

    try {
      setSearchLoading(true);
      let resp = await getVendorFilterLegislation(queryRequest);
      if (resp) {
        setFilteredLegislation(
          getValue(resp, `data`, []).map((item: any) => ({
            ...item,
            value: getValue(item, `legislation_name`, ""),
            label: getValue(item, `legislation_name`, ""),
          }))
        );
        setSearchLoading(false);
      } else {
        setSearchLoading(false);
      }
    } catch (error) {
      setSearchLoading(false);
    }
  };

  const [dashboardInfo, setDashboardInfo] = useState({});
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [auditStatus, setAuditStatus] = useState<any>({});
  // const getDashboardInfo = async () => {
  //   let payload: any = {
  //     location_id: mainParams.id,
  //     month: mainParams.date ? parseInt(mainParams.date.split("-")[1]) : "",
  //     year: mainParams.date ? parseInt(mainParams.date.split("-")[0]) : "",
  //     vendor_id: "",
  //     type: "SUMMERY",
  //   };

  //   // removing null values
  //   Object.keys(payload).forEach((key) => {
  //     if (!payload[key] || payload[key] === undefined) {
  //       delete payload[key];
  //     }
  //   });
  //   let queryRequest = qs.stringify(payload);
  //   try {
  //     setDashboardLoading(true);
  //     let resp = await vendorGetCheckpointLocationDashboardInfo(payload);
  //     if (resp) {
  //       setDashboardLoading(false);
  //       setDashboardInfo(getValue(resp, `data`, ""));
  //     } else {
  //       setDashboardLoading(false);
  //     }
  //   } catch (error) {
  //     setDashboardLoading(false);
  //   }
  // };

  const getDashboardInfo = async () => {
    let user = JSON.parse(getValue(localStorage, `user`, {}));
    let vendor_id = getValue(user, `vendor.id`, "");

    let payload: any = {
      location_id: mainParams.id,
      month: mainParams.date ? parseInt(mainParams.date.split("-")[1]) : "",
      year: mainParams.date ? parseInt(mainParams.date.split("-")[0]) : "",
      vendor_id: vendor_id,
      type: "OVERVIEW",
    };

    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    try {
      setDashboardLoading(true);
      let resp = await vendorCheckpointDetailDashboardInfo(payload);
      if (resp) {
        setDashboardLoading(false);
        setDashboardInfo(getValue(resp, `data[${0}]`, ""));
      } else {
        setDashboardLoading(false);
      }
    } catch (error) {
      setDashboardLoading(false);
    }
  };

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let dates = date ? date : new Date();

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : 100,
      search_text: params.search_text,
      status: params.status,
      sort_by: params.sort_by ? params.sort_by : "newest",
      upload_status: params.update_status,
      // location_id: params.location_id,
      legislation_id: params.legislation_id,
      // is_submitted: params.is_submitted,
      // is_submitted:
      //   params.submit_status === "SUBMITTED"
      //     ? "true"
      //     : params.submit_status === "NOT_SUBMITTED"
      //     ? "false"
      //     : params.is_submitted,
      status_is_submitted: params.submit_status === "SUBMITTED",
      status_is_not_submitted: params.submit_status === "NOT_SUBMITTED",
      location_id: mainParams.id,
      month: mainParams.date ? mainParams.date.split("-")[1] : "",
      year: mainParams.date ? mainParams.date.split("-")[0] : "",
      is_active: true,
      audit_status: params.audit_status,
    };

    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    setIsLoading(true);
    try {
      let resp = await vendorGetCheckpointInfoBySpecificLocation(queryRequest);
      if (resp) {
        setIsLoading(false);
        setLocations(getValue(resp, `data.vendors_checkpoint`, ""));
        setAuditStatus(getValue(resp, `data.audit_status`, ""));
        setReleaseCycleIds(
          getValue(
            resp,
            "data.vendors_checkpoint[0].vendor_checkpoint_audit_cycles[0].release_date_audit_cycle.id",
            ""
          )
        );

        setReleaseCycleDate(
          `${convertDateAsString(
            getValue(
              resp,
              "data.vendors_checkpoint[0].vendor_checkpoint_audit_cycles[0].release_date_audit_cycle.start_date",
              ""
            )
          )} to ${convertDateAsString(
            getValue(
              resp,
              "data.vendors_checkpoint[0].vendor_checkpoint_audit_cycles[0].release_date_audit_cycle.cutoff_date",
              ""
            )
          )}`
        );

        setTotalCount(getValue(resp, `data.pagination.total`, 0));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getDataRefetch = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : 100,
      search_text: params.search_text,
      status: params.status,
      sort_by: params.sort_by ? params.sort_by : "newest",
      upload_status: params.update_status,
      // is_submitted: params.is_submitted,
      is_submitted:
        params.submit_status === "SUBMITTED"
          ? "true"
          : params.submit_status === "NOT_SUBMITTED"
          ? "false"
          : params.is_submitted,
      location_id: mainParams.id,
      month: mainParams.date ? mainParams.date.split("-")[1] : "",
      year: mainParams.date ? mainParams.date.split("-")[0] : "",
      is_active: true,
      legislation_id: params.legislation_id,
      audit_status: params.audit_status,
    };

    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    try {
      let resp = await vendorGetCheckpointInfoBySpecificLocation(queryRequest);
      if (resp) {
        setIsLoading(false);
        setLocations(getValue(resp, `data.vendors_checkpoint`, ""));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */
  const [deleteObj, setDeleteObj] = useState({
    taskId: "",
    id: "",
  });

  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await vendorDeleteCheckpointLocationFile(
        deleteObj.taskId,
        deleteObj.id
      );
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getDataRefetch();
        getDashboardInfo();
      }
    } catch (error) {}
  };

  const handleDeleteFile = async (taskId: string, id: string) => {
    setDeleteObj({
      ...deleteObj,
      taskId: taskId,
      id: id,
    });
    handleDelete();
  };

  const [comments, setComments] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmitTask = async () => {
    try {
      // if (comments) {
      setSubmitLoading(true);
      let payload = {
        ids: selectedIndex,
        audit_status: "PENDING_AUDIT",
        commentsInfo: {
          comments: comments,
          type: "SUBMISSION_COMMENT",
          audit_cycle: selectedReleaseCycleIds,
        },
      };

      if (checkUpload.upload_status === "NOT_UPLOADED") {
        // setSelectedIndex([id]);
        setReleaseCycleId(selectedReleaseCycleIds);
        handleModal2();
      } else {
        let resp = await submitVendorCheckpointTasks(payload);
        if (resp) {
          setSubmitLoading(false);
          toast.success("Submitted successfully");
          if (isOpen2) {
            setIsOpen2(!isOpen2);
          }
          if (checkUpload.upload_status === "NOT_UPLOADED") {
            // setSelectedIndex([id]);
            handleModal2();
          }
          setComments("");
          getDataRefetch();
        }
      }
      setSelectedIndex([]);
      getDashboardInfo();
      // } else {
      //   toast.error("Please add comments");
      //   setSubmitLoading(false);
      // }
    } catch (error) {
      setSubmitLoading(false);
    }
  };

  const handleSubmitTaskComment = async () => {
    try {
      if (comments) {
        setSubmitLoading(true);
        let payload = {
          ids: selectedIndex,
          audit_status: "PENDING_AUDIT",
          commentsInfo: {
            comments: comments,
            type: "SUBMISSION_COMMENT",
            audit_cycle: selectedReleaseCycleIds,
          },
          is_doc_upload_not_applicable:true
        };

        if (checkUpload.upload_status === "NOT_UPLOADED") {
          setReleaseCycleId(selectedReleaseCycleIds);
          handleModal2();
        } else {
          let resp = await submitVendorCheckpointTasks(payload);
          if (resp) {
            setSubmitLoading(false);
            toast.success("Submitted successfully");
            if (isOpen2) {
              setIsOpen2(!isOpen2);
            }
            if (checkUpload.upload_status === "NOT_UPLOADED") {
              handleModal2();
            }
            setComments("");
            getDataRefetch();
          }
        }
        setSelectedIndex([]);
        getDashboardInfo();
      } else {
        toast.error("Please add comments");
        setSubmitLoading(false);
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(100);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: page_no,
    };
    const queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      limit: limit,
      page_no: 1,
    };
    const queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      // removing null values
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      let queryRequest = qs.stringify(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    let payload: any = {
      search_text: e.target.value,
    };
    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  const [isOpen, setIsOpen] = useState(false);
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const [isOpen1, setIsOpen1] = useState(false);
  const handleModal1 = () => {
    setIsOpen1(!isOpen1);
  };

  const [isOpen2, setIsOpen2] = useState(false);
  const handleModal2 = () => {
    setIsOpen2(!isOpen2);
  };

  const handleModal2CloseIcon = () => {
    setSubmitLoading(false);
    setIsOpen2(!isOpen2);
  };

  const [vendorInfo, setVendorInfo] = useState({});
  const handleModalComment = (obj: object) => {
    setVendorInfo(obj);
    handleModal();
  };
  const handleModalCommentCancel = () => {
    setVendorInfo({});
    handleModal();
  };

  const handleModalUpload = (obj: object) => {
    setVendorInfo(obj);
    setSelectedIndex([getValue(obj, `id`, "")]);
    handleModal1();
  };
  const handleModalUploadCancel = () => {
    setVendorInfo({});
    handleModal1();
  };

  const handleUpdateStatus = (update_status: string, submit_status: string) => {
    setSelectedIndex([]);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    delete params.audit_status;

    params.update_status = update_status;
    params.submit_status = submit_status;
    params.page_no = "1";
    Object.keys(params).forEach((key) => {
      if (!params[key] || params[key] === undefined) {
        delete params[key];
      }
    });
    let queryRequest = qs.stringify(params);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!update_status) {
      getData();
    }
  };

  const handleSubmitStatus = (submit_status: string) => {
    setSelectedIndex([]);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());

    delete params.audit_status;

    params.submit_status = submit_status;
    params.page_no = "1";
    Object.keys(params).forEach((key) => {
      if (!params[key] || params[key] === undefined) {
        delete params[key];
      }
    });
    let queryRequest = qs.stringify(params);
    navigate(`${window.location.pathname}?${queryRequest}`);
    // if (!update_status) {
    //   getData();
    // }
  };
  const handleNavigateAuditStatus = (audit_status: string) => {
    setSelectedIndex([]);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    delete params.submit_status;
    delete params.update_status;

    params.audit_status = audit_status;
    params.page_no = "1";
    Object.keys(params).forEach((key) => {
      if (!params[key] || params[key] === undefined) {
        delete params[key];
      }
    });
    let queryRequest = qs.stringify(params);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!audit_status) {
      getData();
    }
  };

  const handleUpdateAuditStatus = (update_status: string) => {
    if (update_status) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      params.is_submitted =
        update_status === "SUBMITTED"
          ? "true"
          : update_status === "NOT_SUBMITTED"
          ? "false"
          : "";
      params.page_no = "1";
      Object.keys(params).forEach((key) => {
        if (!params[key] || params[key] === undefined) {
          delete params[key];
        }
      });
      let queryRequest = qs.stringify(params);
      navigate(`${window.location.pathname}?${queryRequest}`);
      if (!update_status) {
        getData();
      }
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.is_submitted;
      params.page_no = "1";
      Object.keys(params).forEach((key) => {
        if (!params[key] || params[key] === undefined) {
          delete params[key];
        }
      });
      let queryRequest = qs.stringify(params);
      navigate(`${window.location.pathname}?${queryRequest}`);
      if (!update_status) {
        getData();
      }
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Date section                                 */
  /* -------------------------------------------------------------------------- */

  const [date, setDate] = useState<Date | null>(null);
  const handleSubmitDate = () => {
    let dates = moment(date).format("YYYY-MM-DD");
    let payload: any = {
      date: dates,
    };
    // removing null values
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    let queryRequest = qs.stringify(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Checkbox Section                             */
  /* -------------------------------------------------------------------------- */

  const [selectedIndex, setSelectedIndex] = useState<any>([]);
  const [releaseCycleId, setReleaseCycleId] = useState<any>([]);
  const [selectedReleaseCycleIds, setSelectedReleaseCycleIds] = useState<
    string[]
  >([]);

  const [releaseCycleIds, setReleaseCycleIds] = useState<any[]>([]);
  const [releaseCycleDate, setReleaseCycleDate] = useState<any>();

  // const handleChangeCheckbox = (id: String) => {
  //   let selected = selectedIndex.filter((item: string) => item === id);
  //   if (getValue(selected, `length`, 0) === 0) {
  //     selectedIndex.push(id);
  //     setSelectedIndex([...selectedIndex]);
  //   } else {
  //     let selected = selectedIndex.filter((item: string) => item !== id);
  //     setSelectedIndex(selected);
  //   }
  // };

  console.log(releaseCycleIds, "---releaseCycleIds-->");

  const handleChangeCheckbox = (
    id: string,
    releaseCycleId: string | undefined
  ) => {
    setSelectedIndex((prev: any) => {
      const isSelected = prev.includes(id);
      if (isSelected) {
        // Remove id and corresponding releaseCycleId when unchecked
        setSelectedReleaseCycleIds((prevIds) =>
          prevIds.filter((cycleId) => cycleId !== releaseCycleId)
        );
        return prev.filter((item: any) => item !== id);
      } else {
        // Add id and corresponding releaseCycleId when checked
        if (releaseCycleId) {
          setSelectedReleaseCycleIds((prevIds) => [...prevIds, releaseCycleId]);
        }
        return [...prev, id];
      }
    });
  };

  const [all, setAll] = useState("false");
  const handleChangeAllLocations = (value: string) => {
    setAll(value);
    if (value === "true") {
      let loc = locations.map((item: object) => getValue(item, `id`, ""));
      setSelectedIndex(loc);
    } else {
      setSelectedIndex([]);
    }
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  let enableCopy: any =
    getValue(selectedIndex, `length`, 0) === 1
      ? getValue(locations, `length`, 0) > 0 &&
        locations.filter(
          (item: object) =>
            getValue(item, `id`, "") === getValue(selectedIndex, `[${0}]`, "")
        )
      : [];

  const [Compliance, setCompliance] = useState(true);
  const toggleCompliance = () => {
    setCompliance(!Compliance);
  };

  const selectedIDforCheckpoint = locations.filter(
    (item) =>
      selectedIndex.length > 0 && selectedIndex[0] === getValue(item, `id`, "")
  );

  let selectedCheck = locations.filter((item) => {
    if (selectedIndex.includes(getValue(item, `id`, ""))) return item;
  });
  let checkUploaded: any =
    getValue(selectedCheck, `length`, 0) > 0 &&
    selectedCheck.filter((item: any) => {
      if (getValue(item, `upload_status`, "") === "NOT_UPLOADED") return item;
    });

  const handleUploadDocument = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.vendor_checkpoint_ids = selectedIndex;
    Object.keys(params).forEach((key) => {
      if (!params[key] || params[key] === undefined) {
        delete params[key];
      }
    });
    let queryRequest = qs.stringify(params);
    navigate(
      `/checkpoint/details/bulk-upload/${mainParams.id}/${mainParams.date}/${mainParams.code}?${queryRequest}`
    );
  };

  let checkSubmit: any =
    getValue(selectedCheck, `length`, 0) > 0
      ? selectedCheck.filter(
          (item: any) =>
            !getValue(item, `is_submitted`, "") ||
            getValue(item, `audit_status`, "") === "NON_COMPLIED"
        )
      : [];

  let checkUpload: any =
    getValue(selectedCheck, `length`, 0) > 0
      ? selectedCheck.filter(
          (item: any) =>
            !getValue(item, `is_submitted`, "") ||
            getValue(item, `upload_status`, "") === "UPLOADED"
        )
      : [];

  console.log(selectedCheck, "===selectedCheck==");
  console.log(checkUpload, "===checkUpload==");
  /* -------------------------------------------------------------------------- */
  /*                               Sticky Header Section                        */
  /* -------------------------------------------------------------------------- */

  const [sticky, setSticky] = useState("");
  // on render, set listener
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  const isSticky = () => {
    /* Method that will fix header after a specific scrollable */
    const scrollTop = window.scrollY;
    const stickyClass = scrollTop >= 250 ? "is-sticky" : "";
    setSticky(stickyClass);
  };
  const classes = `${sticky}`;

  const handleChangeFilter = (name: string, value: string) => {
    setSelectedIndex([]);
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: value,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                      New Location Search Section                           */
  /* -------------------------------------------------------------------------- */
  const [searchLoading, setSearchLoading] = useState(false);

  const handleTriggerAPI = async (value: string) => {
    if (!value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.legislation_id;
      let payload = {
        ...params,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      getFilterLegislations("", value);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                             Download Reports                               */
  /* -------------------------------------------------------------------------- */
  const [downloadLoading, setDownloadLoading] = useState(false);
  const handleDownloadAuditReport = async () => {
    let payload: any = {
      report_type: "VENDOR_AUDIT_SCORE",
      report_name: `vendor_audit_score_${currentDate()}`,
      month: getValue(locations, `[${0}].month`, ""),
      year: String(getValue(locations, `[${0}].year`, "")),
      region_id: getValue(locations, `[${0}].location.region.id`, ""),
      group_id: getValue(locations, `[${0}].location.group.id`, ""),
      location_id: mainParams.id,
      vendor_id: getValue(locations, `[${0}].vendor.id`, ""),
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
    };
    Object.keys(payload).forEach((key) => {
      if (!payload[key] || payload[key] === undefined) {
        delete payload[key];
      }
    });
    setDownloadLoading(true);
    try {
      let resp = await exportAuditComplete({ ...payload });
      if (resp) {
        setDownloadLoading(false);
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/VENDOR_AUDIT_SCORE`);
      } else {
        setDownloadLoading(false);
      }
    } catch (error) {
      setDownloadLoading(false);
    }
  };

  // Unassigned List

  const [isLoading1, setIsLoading1] = React.useState(false);
  const [unassignedDDList, setUnAssignDDList] = React.useState([]);
  const [page_no1, setPageNo1] = React.useState(1);
  const [limit1, setLimit1] = React.useState(100);
  const [totalCount1, setTotalCount1] = React.useState(0);

  // const [documentRequest, setDocumentRequest] = React.useState<any>({
  // 	document: "",
  // });

  // const [documentRequest, setDocumentRequest] = React.useState<{ [key: number]: string }>({});

  const getUnAssignedDocumentList = async () => {
    let user = JSON.parse(getValue(localStorage, `user`, {}));
    let vendor_id = getValue(user, `vendor.id`, "");

    let payload: any = {
      page_no: page_no1 ? page_no1 : 10,
      page_size: limit1 ? limit1 : 10,
      location_id: mainParams.id,
      month: mainParams.date ? mainParams.date.split("-")[1] : "",
      year: mainParams.date ? mainParams.date.split("-")[0] : "",
      vendor_id: vendor_id,
      // is_assigned: false,
    };
    let queryRequest = qs.stringify(payload);
    setIsLoading1(true);
    try {
      let resp = await vendorCheckpointDocumentlist(queryRequest);
      if (resp) {
        setIsLoading1(false);
        setTotalCount1(getValue(resp, `data.pagination.total`, 0));
        setUnAssignDDList(
          getValue(resp, `data.documents`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `document.name`, ""),
            label: getValue(item, `document.name`, ""),
          }))
        );
      } else {
        setIsLoading1(false);
      }
    } catch (error) {
      setIsLoading1(false);
    }
  };

  // const handleDocumentSelect = (selectedOption: any) => {
  //   setDocumentRequest({
  //     ...documentRequest,
  //     document: selectedOption.id, // store the document ID
  //   });
  // };

  // const handleDocumentSelect = (selectedOption: any, index: number) => {
  //   setDocumentRequest((prev) => ({
  //     ...prev,
  //     [index]: selectedOption ? selectedOption.id : "", // store value based on the row's index
  //   }));
  // };

  const handleDocumentSelect = (e: any, index: number) => {
    const updatedDocumentRequest = [...documentRequest];
    updatedDocumentRequest[index] = e?.id || null;
    setDocumentRequest(updatedDocumentRequest);
  };

  // console.log(documentRequest, "--documentRequest--")
  // const handleUploadSubmitDocument = async (id: any, index: number) => {
  //   const selectedDocumentId = documentRequest[index]; // Access the selected document ID for the specific row

  //   const payload = {
  //     vendor_checkpoint_id: id, // ensure this ID is set
  //     vc_document_ids: [selectedDocumentId], // array containing the selected document ID
  //   };

  //   try {
  //     setIsLoading1(true);
  //     let resp = await VendorCheckpointAssignDocument(payload);
  //     setIsLoading1(false);

  //     if (resp) {
  //       getData();
  //       setUnAssignDDList([]);
  //       getUnAssignedDocumentList();
  //       // console.log(resp, "-- Upload Response --");
  //       // Optionally handle success message or actions here
  //     }
  //   } catch (error) {
  //     setIsLoading1(false);
  //     console.error("Error uploading document:", error);
  //   }
  // };
  const [documentRequest, setDocumentRequest] = useState<Array<any>>([]);

  const handleUploadSubmitDocument = async (id: any, index: number) => {
    const selectedDocumentId = documentRequest[index];

    const payload = {
      vendor_checkpoint_id: id,
      vc_document_ids: [selectedDocumentId],
    };

    try {
      setIsLoading1(true);
      let resp = await VendorCheckpointAssignDocument(payload);
      setIsLoading1(false);

      if (resp) {
        // Clear the document selection after successful save
        const updatedDocumentRequest = [...documentRequest];
        updatedDocumentRequest[index] = null;
        setDocumentRequest(updatedDocumentRequest);

        getData();
        getDashboardInfo();
        setUnAssignDDList([]);
        getUnAssignedDocumentList();
        toast.success("Document saved successfully");
      }
    } catch (error) {
      setIsLoading1(false);
      console.error("Error uploading document:", error);
      toast.error("Error saving document");
    }
  };

  const handleSubmitSingleTask = async (
    id: any,
    status: any,
    releaseCycleId: any
  ) => {
    try {
      // if (comments) {
      setSubmitLoading(true);
      let payload = {
        ids: [id],
        audit_status: "PENDING_AUDIT",
        commentsInfo: {
          comments: comments,
          type: "SUBMISSION_COMMENT",
          audit_cycle: releaseCycleId,
        },
        is_doc_upload_not_applicable:false
      };
      if (status === "NOT_UPLOADED") {
        setSelectedIndex([id]);
        setReleaseCycleId(releaseCycleId);
        handleModal2();
      } else {
        let resp = await submitVendorCheckpointTasks(payload);
        if (resp) {
          setSubmitLoading(false);
          toast.success("Submitted successfully");
          if (status === "NOT_UPLOADED") {
            setSelectedIndex([id]);
            handleModal2();
          }
          setComments("");
          getDataRefetch();
        }
      }
      getDashboardInfo();
      // } else {
      //   toast.error("Please add comments");
      //   setSubmitLoading(false);
      // }
    } catch (error) {
      setSubmitLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="checkpoint-wrapper position-relative checkpoint-detail-wrapper">
        <div className="uploaded-details-wrapper uploaded-details-wrapper--checkpoint">
          <div className="sub-header d-flex align-items-center justify-content-between">
            {/* <div className="checkpoints-timer-wrapper d-flex align-items-center">
							<img src="/images/purple-awesome.svg" className="img-fluid" />
							{dashboardLoading ? (
								<p className="mx-2">Please wait...</p>
							) : (
								<p className="mx-2">
									{getValue(dashboardInfo, `releaseInfo.days`, "")}{" "}
									{getValue(dashboardInfo, `releaseInfo.msg`, "")}
								</p>
							)}
						</div> */}
          </div>
          {/* <Marquee>
            I can be a React component, multiple React components, or just some text.
          </Marquee> */}

          <div className="py-2" style={{ backgroundColor: "#f7f8f9" }}>
            <Marquee speed={50}>
              <span className="text-gray-700 font-medium">
                Your Cut Off Date is{" "}
                <b>
                  {releaseCycleDate === "null to null"
                    ? "- -"
                    : releaseCycleDate}
                </b>
              </span>
            </Marquee>
          </div>
          <div className="dashboard-compliance dashboard-compliance__checkpoint-wrapper">
            <div className="dashboard-compliance__common dashboard-compliance__common-checkpoint d-flex align-items-center justify-content-between">
              <h3 className="dashboard-compliance__title">Activity</h3>
              <h3 className="dashboard-compliance__date dashboard-compliance__date--compliance overview-wrapper__header-date d-flex align-items-center">
                <img
                  src="/images/arrow-drop.svg"
                  className="img-fluid cursor-pointer"
                  onClick={toggleCompliance}
                />
              </h3>
            </div>

            <div
              className={`d-flex align-items-stretch mb-3 justify-content-between d-none 
               
              `}
            >
              {/* ${
                Compliance
                  ? "dashboard-compliance__checkpoint-breakup active"
                  : "dashboard-compliance__checkpoint-breakup"
              } */}
              {/* {breakupAuditnewArray.map((breakupAuditObj, index) => {
								return <BreakupBox auditScore={breakupAuditObj} key={index} />;
							})} */}
              {/* <section className="breakup-box">
                <div className="breakup-box__details">
                  <h6 className="breakup-box__title">
                    {getValue(dashboardInfo, `summery.uploaded_count`, "0")}
                  </h6>
                  <p className="breakup-box__text">{"Uploaded"}</p>
                </div>
                <img
                  src={`/images/upload-image.svg`}
                  className="img-fluid breakup-box-image"
                />
              </section>
              &nbsp;&nbsp;
              <section className="breakup-box">
                <div className="breakup-box__details">
                  <h6 className="breakup-box__title">
                    {getValue(dashboardInfo, `summery.not_uploaded_count`, "0")}
                  </h6>
                  <p className="breakup-box__text">{"Not Uploaded"}</p>
                </div>
                <img
                  src={`/images/not-uploaded-image.svg`}
                  className="img-fluid breakup-box-image"
                />
              </section>
              &nbsp;&nbsp; */}
              <section
                className="breakup-box"
                onClick={() => handleUpdateStatus("UPLOADED", "NOT_SUBMITTED")}
              >
                <div className="breakup-box__details">
                  <h6 className="breakup-box__title">
                    {getValue(
                      dashboardInfo,
                      `uploaded_but_not_submitted_count`,
                      "0"
                    )}
                  </h6>
                  <p className="breakup-box__text">
                    {"Uploaded & Not Submitted"}
                  </p>
                </div>

                <img
                  src={`/images/upload-image.svg`}
                  className="img-fluid breakup-box-image"
                />

                {params.update_status === "UPLOADED" &&
                  params.submit_status === "NOT_SUBMITTED" && (
                    <img
                      src={`/images/close-red.svg`}
                      className="img-fluid breakup-box-image-close cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent triggering the section's onClick
                        handleUpdateStatus("", ""); // Function to remove params
                      }}
                    />
                  )}
              </section>
              &nbsp;&nbsp;
              <section
                className="breakup-box"
                onClick={() => handleUpdateStatus("UPLOADED", "SUBMITTED")}
              >
                <div className="breakup-box__details">
                  <h6 className="breakup-box__title">
                    {getValue(
                      dashboardInfo,
                      `uploaded_and_submitted_count`,
                      "0"
                    )}
                  </h6>
                  <p className="breakup-box__text">{"Uploaded & Submitted"}</p>
                </div>
                <img
                  src={`/images/upload-image.svg`}
                  className="img-fluid breakup-box-image"
                />
                {params.update_status === "UPLOADED" &&
                  params.submit_status === "SUBMITTED" && (
                    <img
                      src={`/images/close-red.svg`}
                      className="img-fluid breakup-box-image-close cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent triggering the section's onClick
                        handleUpdateStatus("", ""); // Function to remove params
                      }}
                    />
                  )}
              </section>
              &nbsp;&nbsp;
              <section
                className="breakup-box"
                onClick={() =>
                  handleUpdateStatus("NOT_UPLOADED", "NOT_SUBMITTED")
                }
              >
                <div className="breakup-box__details">
                  <h6 className="breakup-box__title">
                    {getValue(
                      dashboardInfo,
                      `not_uploaded_and_not_submitted_count`,
                      "0"
                    )}
                  </h6>
                  <p className="breakup-box__text">
                    {"Not Uploaded & Not Submitted"}
                  </p>
                </div>
                <img
                  src={`/images/upload-image.svg`}
                  className="img-fluid breakup-box-image"
                />
                {params.update_status === "NOT_UPLOADED" &&
                  params.submit_status === "NOT_SUBMITTED" && (
                    <img
                      src={`/images/close-red.svg`}
                      className="img-fluid breakup-box-image-close cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent triggering the section's onClick
                        handleUpdateStatus("", ""); // Function to remove params
                      }}
                    />
                  )}
              </section>
              &nbsp;&nbsp;
              <section
                className="breakup-box checkpoint-details-dashboard-info-seperator"
                onClick={() => handleUpdateStatus("NOT_UPLOADED", "SUBMITTED")}
              >
                <div className="breakup-box__details">
                  <h6 className="breakup-box__title">
                    {getValue(
                      dashboardInfo,
                      `submitted_not_uploaded_count`,
                      "0"
                    )}
                  </h6>
                  <p className="breakup-box__text">
                    {"Not Uploaded & Submitted"}
                  </p>
                </div>
                <img
                  src={`/images/upload-image.svg`}
                  className="img-fluid breakup-box-image"
                />
                {params.update_status === "NOT_UPLOADED" &&
                  params.submit_status === "SUBMITTED" && (
                    <img
                      src={`/images/close-red.svg`}
                      className="img-fluid breakup-box-image-close cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent triggering the section's onClick
                        handleUpdateStatus("", ""); // Function to remove params
                      }}
                    />
                  )}
              </section>
              &nbsp; &nbsp;
              <section
                className="breakup-box"
                onClick={() => handleNavigateAuditStatus("PENDING_AUDIT")}
              >
                <div className="breakup-box__details">
                  <h6 className="breakup-box__title">
                    {getValue(dashboardInfo, `pending_audit_count`, "0")}
                  </h6>
                  <p className="breakup-box__text">{"Pending Audit"}</p>
                </div>
                <img
                  src={`/images/upload-image.svg`}
                  className="img-fluid breakup-box-image"
                />
                {params.audit_status === "PENDING_AUDIT" && (
                  <img
                    src={`/images/close-red.svg`}
                    className="img-fluid breakup-box-image-close cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent triggering the section's onClick
                      handleNavigateAuditStatus(""); // Function to remove params
                    }}
                  />
                )}
              </section>
              &nbsp;&nbsp;
              <section
                className="breakup-box"
                onClick={() => handleNavigateAuditStatus("COMPLIED")}
              >
                <div className="breakup-box__details">
                  <h6 className="breakup-box__title">
                    {getValue(dashboardInfo, `complied_count`, "0")}
                  </h6>
                  <p className="breakup-box__text">{"Compiled"}</p>
                </div>
                <img
                  src={`/images/chk-circle-green.svg`}
                  className="img-fluid breakup-box-image"
                />
                {params.audit_status === "COMPLIED" && (
                  <img
                    src={`/images/close-red.svg`}
                    className="img-fluid breakup-box-image-close cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent triggering the section's onClick
                      handleNavigateAuditStatus(""); // Function to remove params
                    }}
                  />
                )}
              </section>
              &nbsp;&nbsp;
              <section
                className="breakup-box"
                onClick={() => handleNavigateAuditStatus("NON_COMPLIED")}
              >
                <div className="breakup-box__details">
                  <h6 className="breakup-box__title">
                    {getValue(dashboardInfo, `non_complied_count`, "0")}
                  </h6>
                  <p className="breakup-box__text">{"Non-Complied"}</p>
                </div>
                <img
                  src={`/images/upload-image.svg`}
                  className="img-fluid breakup-box-image"
                />
                {params.audit_status === "NON_COMPLIED" && (
                  <img
                    src={`/images/close-red.svg`}
                    className="img-fluid breakup-box-image-close cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent triggering the section's onClick
                      handleNavigateAuditStatus(""); // Function to remove params
                    }}
                  />
                )}
              </section>
              &nbsp;&nbsp;
              {/* <section className="breakup-box" onClick={() => handleNavigateAuditStatus("PARTIALLY_COMPLIED")}>
                <div className="breakup-box__details">
                  <h6 className="breakup-box__title">
                    {getValue(
                      dashboardInfo,
                      `partially_complied_count`,
                      "0"
                    )}
                  </h6>
                  <p className="breakup-box__text">{"Partially Complied"}</p>
                </div>
                <img
                  src={`/images/flaky.svg`}
                  className="img-fluid breakup-box-image"
                />
                {params.audit_status === "PARTIALLY_COMPLIED"  && (
                  <img
                    src={`/images/close-red.svg`}
                    className="img-fluid breakup-box-image-close cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent triggering the section's onClick
                      handleNavigateAuditStatus(""); // Function to remove params
                    }}                
                  />
                )}
              </section>
              &nbsp;&nbsp; */}
              <section
                className="breakup-box"
                onClick={() => handleNavigateAuditStatus("NOT_APPLICABLE")}
              >
                <div className="breakup-box__details">
                  <h6 className="breakup-box__title">
                    {getValue(dashboardInfo, `not_applicable_count`, "0")}
                  </h6>
                  <p className="breakup-box__text">{"Not Applicable"}</p>
                </div>
                <img
                  src={`/images/upload-image.svg`}
                  className="img-fluid breakup-box-image"
                />
                {params.audit_status === "NOT_APPLICABLE" && (
                  <img
                    src={`/images/close-red.svg`}
                    className="img-fluid breakup-box-image-close cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent triggering the section's onClick
                      handleNavigateAuditStatus(""); // Function to remove params
                    }}
                  />
                )}
              </section>
              {/* &nbsp;&nbsp;
							<section className="breakup-box">
								<div className="breakup-box__details">
									<h6 className="breakup-box__title">
										{getValue(
											dashboardInfo,
											`summery.send_back_to_vendor_count`,
											"0"
										)}
									</h6>
									<p className="breakup-box__text">{"Sent Back to Vendor"}</p>
								</div>
								<img
									src={`/images/upload-image.svg`}
									className="img-fluid breakup-box-image"
								/>
							</section> */}
            </div>

            <div
              className={`d-flex align-items-stretch mb-3 
              ${
                Compliance
                  ? "dashboard-compliance__checkpoint-breakup active"
                  : "dashboard-compliance__checkpoint-breakup"
              }               
               `}
            >
              <section
                className="breakup-box"
                onClick={() => handleSubmitStatus("SUBMITTED")}
              >
                <div className="breakup-box__details">
                  <h6 className="breakup-box__title">
                    {getValue(dashboardInfo, `submitted_count`, "0")}
                  </h6>
                  <p className="breakup-box__text">{"Submitted"}</p>
                </div>

                <img
                  src={`/images/chk-circle-green.svg`}
                  className="img-fluid breakup-box-image"
                />

                {params.submit_status === "SUBMITTED" && (
                  <img
                    src={`/images/close-red.svg`}
                    className="img-fluid breakup-box-image-close cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent triggering the section's onClick
                      handleSubmitStatus(""); // Function to remove params
                    }}
                  />
                )}
              </section>
              &nbsp;&nbsp;
              <section
                className="breakup-box"
                onClick={() => handleSubmitStatus("NOT_SUBMITTED")}
              >
                <div className="breakup-box__details">
                  <h6 className="breakup-box__title">
                    {getValue(dashboardInfo, `not_submitted_count`, "0")}
                  </h6>
                  <p className="breakup-box__text">{"Not Submitted"}</p>
                </div>

                {/* <img
                  src={`/images/upload-image.svg`}
                  className="img-fluid breakup-box-image"
                /> */}

                <img
                  src={`/images/close-circle-red.svg`}
                  className="img-fluid breakup-box-image"
                />

                {params.submit_status === "NOT_SUBMITTED" && (
                  <img
                    src={`/images/close-red.svg`}
                    className="img-fluid breakup-box-image-close cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent triggering the section's onClick
                      handleSubmitStatus(""); // Function to remove params
                    }}
                  />
                )}
              </section>
              &nbsp;&nbsp;
            </div>
          </div>
          <div className="uploaded-details-wrapper__header-checkpoint mt-4">
            <div className="d-flex align-items-center justify-content-between mb-3">
              <div className="d-flex align-items-center">
                <NavLink to={`/checkpoint?date=${mainParams.date}`}>
                  <img src="/images/back-arrow.svg" className="img-fluid " />
                </NavLink>
                <p className="uploaded-details-wrapper__date px-2">
                  {mainParams.code} -
                  {moment(new Date(mainParams.date)).format("MMM, YYYY")}
                </p>
              </div>

              <div className="d-flex align-items-center gap-3">
                <div>
                  <b>Score: </b>
                  {getValue(mainParams, `score`, "")}%
                </div>

                {(Number(getValue(auditStatus, `cycle_max`, 0)) === 1 &&
                  getValue(mainParams, `audit_status`, "") ===
                    "audit-completed") ||
                Number(getValue(auditStatus, `cycle_max`, 0)) > 1 ? (
                  <>
                    <button
                      className="common-button"
                      onClick={handleDownloadAuditReport}
                    >
                      {downloadLoading ? (
                        "Please wait..."
                      ) : (
                        <>
                          {" "}
                          <img
                            src={`/images/download.svg`}
                            className="img-fluid breakup-box-image"
                          />{" "}
                          Download Report{" "}
                        </>
                      )}
                    </button>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-between mt-5">
              <div className="d-flex">
                <div className="uploaded-details-wrapper__dropdown-button">
                  <h6 className="uploaded-details-wrapper__dropdown-title">
                    Status
                  </h6>
                  <UncontrolledDropdown className="uploaded-details-wrapper-dropdown combo-upload-wrap">
                    <DropdownToggle caret>
                      {/* {
                      params.update_status == "UPLOADED" && params.submit_status == "SUBMITTED"
                        ? "Uploaded & Submitted"
                        : params.update_status == "UPLOADED" && params.submit_status == "NOT_SUBMITTED"
                        ? "Uploaded & Not Submitted"
                        : params.update_status == "NOT_UPLOADED" && params.submit_status == "SUBMITTED"
                        ? "Not Uploaded & Submitted"
                        : params.update_status == "NOT_UPLOADED" && params.submit_status == "NOT_SUBMITTED"
                        ? "Not Uploaded & Not Submitted"
                        : "All"
                    } */}

                      {params.submit_status == "SUBMITTED"
                        ? "Submitted"
                        : params.submit_status == "NOT_SUBMITTED"
                        ? "Not Submitted"
                        : "All"}
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem onClick={() => handleUpdateStatus("", "")}>
                        <p>All</p>
                      </DropdownItem>
                      {/* <DropdownItem
                        onClick={() => handleUpdateStatus("UPLOADED", "SUBMITTED")}
                      >
                        Uploaded & Submitted
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => handleUpdateStatus("UPLOADED", "NOT_SUBMITTED")}
                      >
                        Uploaded & Not Submitted
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => handleUpdateStatus("NOT_UPLOADED", "SUBMITTED")}
                      >
                        Not Uploaded & Submitted
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => handleUpdateStatus("NOT_UPLOADED", "NOT_SUBMITTED")}
                      >
                        Not Uploaded & Not Submitted
                      </DropdownItem> */}
                      <DropdownItem
                        onClick={() => handleSubmitStatus("SUBMITTED")}
                      >
                        Submitted
                      </DropdownItem>

                      <DropdownItem
                        onClick={() => handleSubmitStatus("NOT_SUBMITTED")}
                      >
                        Not Submitted
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
                <div className="uploaded-details-wrapper__dropdown-button d-none">
                  <h6 className="uploaded-details-wrapper__dropdown-title">
                    Submit Status
                  </h6>
                  <UncontrolledDropdown className="uploaded-details-wrapper-dropdown">
                    <DropdownToggle caret>
                      {params.is_submitted == "true"
                        ? "Submitted"
                        : params.is_submitted == "false"
                        ? "Not Submitted"
                        : "All"}
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem onClick={() => handleUpdateAuditStatus("")}>
                        <p>All</p>
                      </DropdownItem>

                      <DropdownItem
                        onClick={() => handleUpdateAuditStatus("SUBMITTED")}
                      >
                        Submitted
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => handleUpdateAuditStatus("NOT_SUBMITTED")}
                      >
                        Not Submitted
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
                <div className="d-none">
                  <h6 className="uploaded-details-wrapper__dropdown-title">
                    Legislation
                  </h6>
                  <div className="uploaded-details-wrapper__dropdown-button">
                    {/* <InputField
											inputType="INPUT_REACT_SELECT"
											placeholder="Choose Legislation"
											className="headcount-popup-wrapper__select"
											name="legislation_id"
											id="legislation_id"
											options={filteredLegislation}
											value={
												getValue(filteredLegislation, `length`, 0) > 0 &&
												filteredLegislation.filter(
													(item: object) =>
														getValue(item, `id`, "") ==
														getValue(params, `legislation_id`, "")
												)
											}
											onChange={(e: any) =>
												handleChangeFilter(
													"legislation_id",
													getValue(e, `id`, "")
												)
											}
											label="Country"
											isClear
										/> */}

                    <SearchableDropdownSelect
                      placeholder={"Search Legislation"}
                      options={filteredLegislation}
                      searchLoading={searchLoading}
                      handleChange={(val: any) => handleTriggerAPI(val)}
                      handleClick={(e: any) =>
                        handleChangeFilter("legislation_id", e.id)
                      }
                      value={
                        getValue(filteredLegislation, `length`, 0) > 0 &&
                        filteredLegislation.filter(
                          (item: object) =>
                            getValue(item, `id`, "") ==
                            getValue(params, `legislation_id`, "")
                        )[0]
                      }
                      label="label"
                      id="id"
                      name="Legislation"
                    />
                  </div>
                </div>
              </div>

              <div className="button-wrapper d-flex align-items-end gap">
                {getValue(mainParams, `listenable`, "") === "0" ? (
                  <button
                    className="common-button"
                    disabled={
                      getValue(mainParams, `listenable`, "") === "0" ||
                      getValue(selectedIndex, `length`, 0) !== 1 ||
                      getValue(selectedIndex, `length`, 0) === 0 ||
                      getValue(enableCopy, `[${0}].documents.length`, 0) == 0
                    }
                  >
                    {getValue(mainParams, `listenable`, "") === "0" ||
                    getValue(selectedIndex, `length`, 0) !== 1 ||
                    getValue(selectedIndex, `length`, 0) === 0 ||
                    getValue(enableCopy, `[${0}].documents.length`, 0) == 0 ? (
                      <img
                        src="/images/content-copy-white.svg"
                        className="img-fluid mr-2"
                      />
                    ) : (
                      <img
                        src="/images/content-copy.svg"
                        className="img-fluid mr-2"
                      />
                    )}
                    Copy Document
                  </button>
                ) : (
                  <NavLink
                    to={`/checkpoint/details/copy-documents/${mainParams.id}/${
                      mainParams.date
                    }/${mainParams.code}/${getValue(
                      selectedIDforCheckpoint,
                      `[${0}].checkpoint.id`,
                      ""
                    )}/${getValue(
                      selectedIDforCheckpoint,
                      `[${0}].id`,
                      ""
                    )}/${getValue(mainParams, `listenable`, "")}/${getValue(
                      mainParams,
                      `audit_status`,
                      ""
                    )}/${getValue(mainParams, `score`, "")}`}
                  >
                    <button
                      className="common-button"
                      disabled={
                        getValue(selectedIndex, `length`, 0) !== 1 ||
                        getValue(selectedIndex, `length`, 0) === 0 ||
                        getValue(enableCopy, `[${0}].documents.length`, 0) == 0
                      }
                    >
                      {getValue(selectedIndex, `length`, 0) !== 1 ||
                      getValue(selectedIndex, `length`, 0) === 0 ||
                      getValue(enableCopy, `[${0}].documents.length`, 0) ==
                        0 ? (
                        <img
                          src="/images/content-copy-white.svg"
                          className="img-fluid mr-2"
                        />
                      ) : (
                        <img
                          src="/images/content-copy.svg"
                          className="img-fluid mr-2"
                        />
                      )}
                      Copy Document
                    </button>
                  </NavLink>
                )}
                {/* {!checkUploaded || getValue(checkUploaded, `length`, 0) > 0 ? (
									<button
										className="common-button"
										disabled={
											!checkUploaded || getValue(checkUploaded, `length`, 0) > 0
										}
									>
										<img
											src="/images/bulk-upload-white.svg"
											className="img-fluid"
										/>
										Bulk Upload
									</button>
								) : ( */}
                {getValue(mainParams, `listenable`, "") === "0" ? (
                  <button
                    className="common-button"
                    disabled
                    // onClick={() => handleUploadDocument()}
                  >
                    <img src="/images/bulk-upload.svg" className="img-fluid" />
                    Bulk Upload
                  </button>
                ) : (
                  <NavLink
                    to={`/checkpoint/details/bulk-upload/${mainParams.id}/${
                      mainParams.date
                    }/${mainParams.code}/${getValue(
                      mainParams,
                      `listenable`,
                      ""
                    )}/${getValue(mainParams, `audit_status`, "")}/${getValue(
                      mainParams,
                      `score`,
                      ""
                    )}`}
                    // ?audit_cycle=${releaseCycleIds || ""}
                  >
                    <button
                      className="common-button"
                      // onClick={() => handleUploadDocument()}
                    >
                      <img
                        src="/images/bulk-upload.svg"
                        className="img-fluid"
                      />
                      Bulk Upload
                    </button>
                  </NavLink>
                )}
                {/* )} */}

                {submitLoading ? (
                  <button className="ascent-button ascent-button--secondary ascent-button--checkpoint d-flex align-items-center">
                    <img src="/images/white-check.svg" className="img-fluid" />
                    Please wait...
                  </button>
                ) : checkSubmit.length === selectedIndex.length ? (
                  <button
                    className="ascent-button ascent-button--secondary ascent-button--checkpoint d-flex align-items-center"
                    // onClick={handleModal2}
                    onClick={
                      selectedCheck.some(
                        (item: any) => item.upload_status === "NOT_UPLOADED"
                      )
                        ? handleModal2
                        : handleSubmitTask
                    }
                    disabled={
                      selectedIndex.length === 0 ||
                      getValue(mainParams, `listenable`, "") === "0" ||
                      !(
                        checkUpload.every(
                          (item: any) => item.upload_status === "UPLOADED"
                        ) ||
                        checkUpload.every(
                          (item: any) => item.upload_status === "NOT_UPLOADED"
                        )
                      )
                    }
                  >
                    <img src="/images/white-check.svg" className="img-fluid" />
                    Submit for Audit Review
                  </button>
                ) : (
                  <button
                    className="ascent-button ascent-button--secondary ascent-button--checkpoint d-flex align-items-center"
                    // onClick={handleModal2}
                    onClick={
                      checkUpload.some(
                        (item: any) => item.upload_status === "NOT_UPLOADED"
                      )
                        ? handleModal2
                        : handleSubmitTask
                    }
                    disabled
                  >
                    <img src="/images/white-check.svg" className="img-fluid" />
                    Submit for Audit Review
                  </button>
                )}
              </div>
            </div>
          </div>

          <div>
            {/*  --------------------------------------------- Sticky Header Starts ------------------------------------------------ */}
            <div
              className={`${
                classes === "is-sticky" ? "navHideShow" : "d-none"
              }`}
            >
              <section className="navigation-bar-wrapper">
                <div className="d-flex align-items-center justify-content-between">
                  <div></div>
                  <div className="d-flex" style={{ alignItems: "center" }}>
                    {getValue(mainParams, `listenable`, "") === "0" ? (
                      <button
                        style={{ marginRight: "10px" }}
                        className="common-button"
                        disabled={
                          getValue(mainParams, `listenable`, "") === "0" ||
                          getValue(selectedIndex, `length`, 0) !== 1 ||
                          getValue(selectedIndex, `length`, 0) === 0 ||
                          getValue(enableCopy, `[${0}].documents.length`, 0) ==
                            0
                        }
                      >
                        {getValue(mainParams, `listenable`, "") === "0" ||
                        getValue(selectedIndex, `length`, 0) !== 1 ||
                        getValue(selectedIndex, `length`, 0) === 0 ||
                        getValue(enableCopy, `[${0}].documents.length`, 0) ==
                          0 ? (
                          <img
                            src="/images/content-copy-white.svg"
                            className="img-fluid mr-2"
                          />
                        ) : (
                          <img
                            src="/images/content-copy.svg"
                            className="img-fluid mr-2"
                          />
                        )}
                        Copy Document
                      </button>
                    ) : (
                      <NavLink
                        to={`/checkpoint/details/copy-documents/${
                          mainParams.id
                        }/${mainParams.date}/${mainParams.code}/${getValue(
                          selectedIDforCheckpoint,
                          `[${0}].checkpoint.id`,
                          ""
                        )}/${getValue(
                          selectedIDforCheckpoint,
                          `[${0}].id`,
                          ""
                        )}/${getValue(mainParams, `listenable`, "")}/${getValue(
                          mainParams,
                          `audit_status`,
                          ""
                        )}/${getValue(mainParams, `score`, "")}`}
                      >
                        <button
                          className="common-button"
                          disabled={
                            getValue(selectedIndex, `length`, 0) !== 1 ||
                            getValue(selectedIndex, `length`, 0) === 0 ||
                            getValue(
                              enableCopy,
                              `[${0}].documents.length`,
                              0
                            ) == 0
                          }
                          style={{ marginRight: "10px" }}
                        >
                          {getValue(selectedIndex, `length`, 0) !== 1 ||
                          getValue(selectedIndex, `length`, 0) === 0 ||
                          getValue(enableCopy, `[${0}].documents.length`, 0) ==
                            0 ? (
                            <img
                              src="/images/content-copy-white.svg"
                              className="img-fluid mr-2"
                            />
                          ) : (
                            <img
                              src="/images/content-copy.svg"
                              className="img-fluid mr-2"
                            />
                          )}
                          Copy Document
                        </button>
                      </NavLink>
                    )}

                    {getValue(mainParams, `listenable`, "") === "0" ? (
                      <button
                        className="common-button"
                        disabled
                        style={{ marginRight: "10px" }}
                      >
                        <img
                          src="/images/bulk-upload.svg"
                          className="img-fluid"
                        />
                        Bulk Upload
                      </button>
                    ) : (
                      <NavLink
                        to={`/checkpoint/details/bulk-upload/${mainParams.id}/${
                          mainParams.date
                        }/${mainParams.code}/${getValue(
                          mainParams,
                          `listenable`,
                          ""
                        )}/${getValue(
                          mainParams,
                          `audit_status`,
                          ""
                        )}/${getValue(mainParams, `score`, "")}`}
                      >
                        <button
                          className="common-button"
                          // onClick={() => handleUploadDocument()}
                          style={{ marginRight: "10px" }}
                        >
                          <img
                            src="/images/bulk-upload.svg"
                            className="img-fluid"
                          />
                          Bulk Upload
                        </button>
                      </NavLink>
                    )}

                    {submitLoading ? (
                      <button className="ascent-button ascent-button--secondary ascent-button--checkpoint d-flex align-items-center">
                        <img
                          src="/images/white-check.svg"
                          className="img-fluid"
                        />
                        Please wait...
                      </button>
                    ) : checkSubmit.length === selectedIndex.length ? (
                      <button
                        className="ascent-button ascent-button--secondary ascent-button--checkpoint d-flex align-items-center"
                        style={{ border: "1px solid white" }}
                        // onClick={handleModal2}
                        onClick={
                          selectedCheck.some(
                            (item: any) => item.upload_status === "NOT_UPLOADED"
                          )
                            ? handleModal2
                            : handleSubmitTask
                        }
                        disabled={
                          selectedIndex.length === 0 ||
                          getValue(mainParams, `listenable`, "") === "0" ||
                          !(
                            checkUpload.every(
                              (item: any) => item.upload_status === "UPLOADED"
                            ) ||
                            checkUpload.every(
                              (item: any) =>
                                item.upload_status === "NOT_UPLOADED"
                            )
                          )
                          // ||
                          // checkUpload.some((item:any) => item.upload_status === "NOT_UPLOADED")
                        }
                      >
                        <img
                          src="/images/white-check.svg"
                          className="img-fluid"
                        />
                        Submit for Audit Review
                      </button>
                    ) : (
                      <button
                        className="ascent-button ascent-button--secondary ascent-button--checkpoint d-flex align-items-center"
                        // onClick={handleModal2}
                        onClick={
                          checkUpload.some(
                            (item: any) => item.upload_status === "NOT_UPLOADED"
                          )
                            ? handleModal2
                            : handleSubmitTask
                        }
                        disabled
                      >
                        <img
                          src="/images/white-check.svg"
                          className="img-fluid"
                        />
                        Submit for Audit Review
                      </button>
                    )}
                  </div>
                </div>
              </section>

              <div className="py-2" style={{ backgroundColor: "#f7f8f9" }}>
                <Marquee speed={50}>
                  <span className="text-gray-700 font-medium">
                    Your Cut Off Date is <b>{releaseCycleDate}</b>
                  </span>
                </Marquee>
              </div>
            </div>

            {/*  ----------------------------------------------- Sticky Header Ends ------------------------------------------------- */}

            <div className="uploaded-details-wrapper__header uploaded-details-wrapper__header-checkpoint  d-flex">
              <div
                className="uploaded-details-wrapper-form-group form-group"
                style={{ width: "40px", maxWidth: "40px", minWidth: "40px" }}
              >
                Sr No.
              </div>
              <div className="uploaded-details-wrapper-form-group form-group">
                <label
                  className="m-0 position-relative"
                  htmlFor="header-checkbox"
                >
                  <input
                    type="checkbox"
                    className="default-checkbox"
                    id="header-checkbox"
                    onChange={() =>
                      handleChangeAllLocations(
                        all === "true" ? "false" : "true"
                      )
                    }
                    checked={
                      locations.length === selectedIndex.length &&
                      all === "true"
                    }
                  />
                  <div className="custom-checkbox">
                    <img
                      src="/images/uploaded-details/tick.svg"
                      className="img-fluid uploaded-tick"
                    />
                  </div>
                </label>
              </div>
              <div className="uploaded-details-wrapper__task-wrapper d-none">
                {/* <h6 className="uploaded-details-wrapper__header-title">
                  Form Name
                </h6> */}
                {/* <p className="uploaded-details-wrapper__header-text">Task ID</p> */}
                <h6 className="uploaded-details-wrapper__header-title">
                  Task ID
                </h6>
                {/* <p className="uploaded-details-wrapper__header-text">Checkpoint ID</p> */}
              </div>
              <div
                className="uploaded-details-wrapper__legislation-wrapper"
                style={{ width: "200px", maxWidth: "200px", minWidth: "200px" }}
              >
                <h6 className="uploaded-details-wrapper__header-title">
                  Title
                </h6>
                {/* <p className="uploaded-details-wrapper__header-text">
                  Type
                </p> */}
              </div>

              <div
                className="uploaded-details-wrapper__legislation-wrapper"
                style={{ width: "150px", maxWidth: "150px", minWidth: "150px" }}
              >
                <h6 className="uploaded-details-wrapper__header-title">ACT</h6>
                <p className="uploaded-details-wrapper__header-text">Detail</p>
              </div>

              <div className="uploaded-details-wrapper__status-wrapper">
                <h6 className="uploaded-details-wrapper__header-title">
                  Upload Status
                </h6>
                <p className="uploaded-details-wrapper__header-text">
                  Audit Status
                </p>
              </div>
              <div
                className="uploaded-denpmails-wrapper__status-wrapper"
                style={{ width: "175px" }}
              >
                <h6 className="uploaded-details-wrapper__header-title">
                  Bulk Upload Keyword
                </h6>
              </div>
            </div>

            {isLoading ? (
              <Loader />
            ) : getValue(locations, `length`, 0) > 0 ? (
              locations.map((uploadDetailsObj: object, index: number) => {
                const vendorCheckpointAuditCycles = getValue(
                  uploadDetailsObj,
                  "vendor_checkpoint_audit_cycles",
                  []
                );
                // const releaseCycleId = vendorCheckpointAuditCycles
                // .find((cycle:any) => {
                //   const releaseDateAuditCycle = getValue(cycle, 'release_date_audit_cycle', null);
                //   return releaseDateAuditCycle && Object.keys(releaseDateAuditCycle).length > 0;
                // })?.id;

                const releaseAuditCycleId = vendorCheckpointAuditCycles.find(
                  (cycle: any) => {
                    const releaseDateAuditCycle = getValue(
                      cycle,
                      "release_date_audit_cycle",
                      null
                    );
                    return (
                      releaseDateAuditCycle &&
                      Object.keys(releaseDateAuditCycle).length > 0
                    );
                  }
                )?.release_date_audit_cycle?.id;

                const disabledStatus =
                  getValue(uploadDetailsObj, `audit_status`, "") ===
                    "COMPLIED" ||
                  getValue(uploadDetailsObj, `audit_status`, "") ===
                    "NOT_APPLICABLE";

                // console.log(uploadDetailsObj, "===uploadDetailsObj===>", releaseCycleId, "===releaseCycleId==>")
                return (
                  <div className="uploaded-details-wrapper__body-checkpoint-border uploaded-details-wrapper__header-checkpoint">
                    <div
                      className="uploaded-details-wrapper__body  uploaded-details-wrapper__body--checkpoint  d-flex"
                      key={`details-${index}`}
                    >
                      {/* 1 Column  */}
                      <div
                        className="uploaded-details-wrapper-form-group form-group"
                        style={{
                          width: "40px",
                          maxWidth: "40px",
                          minWidth: "40px",
                        }}
                      >
                        <span className="mx-2">{index + 1}.</span>
                      </div>

                      {/* 2 Column  */}
                      <div className="uploaded-details-wrapper-form-group form-group">
                        <label
                          className="m-0 position-relative"
                          htmlFor={`details-${index}`}
                        >
                          <input
                            type="checkbox"
                            className="default-checkbox"
                            id={`details-${index}`}
                            checked={selectedIndex.includes(
                              getValue(uploadDetailsObj, `id`, "")
                            )}
                            // onChange={() => {
                            //   const id = getValue(uploadDetailsObj, `id`, "");
                            //   handleChangeCheckbox(id);
                            // }

                            //   // handleChangeCheckbox(
                            //   //   getValue(uploadDetailsObj, `id`, "")
                            //   // ),
                            //   // setReleaseCycleId(releaseCycleId),
                            // }

                            onChange={() => {
                              const id = getValue(uploadDetailsObj, `id`, "");
                              handleChangeCheckbox(id, releaseAuditCycleId);
                            }}
                            disabled={
                              getValue(uploadDetailsObj, `audit_status`, "") ===
                                "COMPLIED" ||
                              getValue(uploadDetailsObj, `audit_status`, "") ===
                                "NOT_APPLICABLE"
                            }
                          />
                          <div
                            className="custom-checkbox"
                            style={{
                              cursor:
                                getValue(
                                  uploadDetailsObj,
                                  `audit_status`,
                                  ""
                                ) === "COMPLIED" ||
                                getValue(
                                  uploadDetailsObj,
                                  `audit_status`,
                                  ""
                                ) === "NOT_APPLICABLE"
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                          >
                            <img
                              src="/images/uploaded-details/tick.svg"
                              className="img-fluid uploaded-tick"
                              alt=""
                            />
                          </div>
                        </label>
                      </div>

                      {/* 3 Column  */}
                      <label
                        className="uploaded-details-wrapper__task-wrapper cursor-pointer d-none"
                        htmlFor={`details-${index}`}
                      >
                        {/* <h6 className="uploaded-details-wrapper__body-title">
                          {getValue(uploadDetailsObj, `checkpoint.form_no`, "")}
                        </h6> */}
                        <h6 className="uploaded-details-wrapper__body-title">
                          {getValue(uploadDetailsObj, `task_id`, "")}
                          {parseInt(
                            getValue(uploadDetailsObj, `submit_count`, 1)
                          ) > 1 && (
                            <div
                              style={{
                                position: "absolute",
                                height: "20px",
                                width: "20px",
                                borderRadius: "10px",
                                backgroundColor: "#ff2d55",
                                right: "-21px",
                                top: "-6px",
                              }}
                              data-tip
                              data-for="count"
                            >
                              <p
                                style={{
                                  color: "white",
                                  textAlign: "center",
                                  fontSize: "12px",
                                  alignContent: "center",
                                  marginTop: "3px",
                                }}
                              >
                                {getValue(uploadDetailsObj, `submit_count`, "")}
                              </p>
                            </div>
                          )}{" "}
                        </h6>
                        {/* <p className="uploaded-details-wrapper__body-text">
                          <span style={{ position: "relative" }}>
                            {getValue(uploadDetailsObj, `task_id`, "")}

                            {parseInt(
                              getValue(uploadDetailsObj, `submit_count`, 1)
                            ) > 1 && (
                              <div
                                style={{
                                  position: "absolute",
                                  height: "20px",
                                  width: "20px",
                                  borderRadius: "10px",
                                  backgroundColor: "#ff2d55",
                                  right: "-21px",
                                  top: "-6px",
                                }}
                                data-tip
                                data-for="count"
                              >
                                <p
                                  style={{
                                    color: "white",
                                    textAlign: "center",
                                    fontSize: "12px",
                                    alignContent: "center",
                                    marginTop: "3px",
                                  }}
                                >
                                  {getValue(
                                    uploadDetailsObj,
                                    `submit_count`,
                                    ""
                                  )}
                                </p>
                              </div>
                            )}
                          </span>
                        </p> */}
                        {/* <p className="uploaded-details-wrapper__body-text">
                          {getValue(
                            uploadDetailsObj,
                            `checkpoint.checkpoint_id`,
                            ""
                          )}
                        </p> */}
                      </label>

                      {/* 4 Column  */}
                      <div
                        className="uploaded-details-wrapper__legislation-wrapper"
                        style={{
                          width: "200px",
                          maxWidth: "200px",
                          minWidth: "200px",
                        }}
                      >
                        <h6 className="uploaded-details-wrapper__body-title">
                          {/* {getValue(
                            uploadDetailsObj,
                            `checkpoint.legislation.legislation_name`,
                            ""
                          )} */}
                          {getValue(
                            uploadDetailsObj,
                            `checkpoint.legislation_rule.rule_name`,
                            "-"
                          )}
                        </h6>

                        {/* <p className="uploaded-details-wrapper__body-text">
                          {getValue(
                            uploadDetailsObj,
                            `checkpoint.compliance_activity`,
                            ""
                          )}
                        </p> */}
                      </div>

                      {/* 5 Column  */}
                      <div
                        className="uploaded-details-wrapper__legislation-wrapper"
                        style={{
                          width: "150px",
                          maxWidth: "150px",
                          minWidth: "150px",
                        }}
                      >
                        <h6 className="uploaded-details-wrapper__body-title">
                          {getValue(
                            uploadDetailsObj,
                            `checkpoint.legislation.legislation_name`,
                            ""
                          )}
                        </h6>
                        <p className="uploaded-details-wrapper__body-text">
                          {getValue(
                            uploadDetailsObj,
                            `checkpoint.compliance_activity`,
                            "-"
                          )}
                        </p>
                      </div>

                      {/* 6 Column  */}
                      <div className="uploaded-details-wrapper__status-wrapper">
                        <h6
                          className={`uploaded-details-wrapper__body-title uploaded-details-wrapper__body-title--${
                            getValue(uploadDetailsObj, `upload_status`, "") ===
                            "NOT_UPLOADED"
                              ? "red"
                              : "green"
                          }`}
                        >
                          {formatText(
                            getValue(uploadDetailsObj, `upload_status`, "")
                          )}
                        </h6>
                        <p
                          className="uploaded-details-wrapper__body-text"
                          style={{
                            color:
                              getValue(uploadDetailsObj, `audit_status`, "") ===
                              "NON_COMPLIED"
                                ? "#d7242e"
                                : "",
                          }}
                        >
                          {formatText(
                            getValue(uploadDetailsObj, `audit_status`, "")
                          )}
                        </p>
                      </div>

                      {/* 7 Column  */}
                      <div style={{ width: "175px" }}>
                        {/* <h6 className="uploaded-details-wrapper__body-title">
                          {getValue(
                            uploadDetailsObj,
                            `checkpoint.legislation_rule.rule_name`,
                            "-"
                          )}
                        </h6> */}
                        <h6
                          className="uploaded-details-wrapper__body-title cursor-pointer bulk-keyword-text-holder"
                          data-tip
                          data-for={`bulk_upload_keyword${index}`}
                        >
                          {getValue(
                            uploadDetailsObj,
                            `checkpoint.bulk_upload_keyword`,
                            "-"
                          )}
                        </h6>
                        <ReactTooltip id={`bulk_upload_keyword${index}`}>
                          <div>
                            {getValue(
                              uploadDetailsObj,
                              `checkpoint.bulk_upload_keyword`,
                              "-"
                            )}
                          </div>
                        </ReactTooltip>
                      </div>
                      {/* 8 Column  */}
                      <div className="uploaded-details-wrapper__icons-wrapper">
                        <div>
                          <div className="d-flex gap-3 justify-content-end">
                            {
                              // getValue(uploadDetailsObj, `is_submitted`, "") ? (
                              getValue(uploadDetailsObj, "audit_status", "") ===
                                "COMPLIED" ||
                              getValue(uploadDetailsObj, "audit_status", "") ===
                                "NOT_APPLICABLE" ||
                              getValue(uploadDetailsObj, "audit_status", "") ===
                                "PENDING_AUDIT" ? (
                                <div data-tip data-for="happyFace1">
                                  <img
                                    src="/images/audit-review/check-green.svg"
                                    className="img-fluid cursor-pointer"
                                    height={36}
                                    width={36}
                                    alt=""
                                  />
                                </div>
                              ) : (
                                <div data-tip data-for="happyFace2">
                                  <img
                                    src="/images/audit-review/check-gray.svg"
                                    className="img-fluid cursor-pointer"
                                    height={36}
                                    width={36}
                                    alt=""
                                  />
                                </div>
                              )
                            }
                            <ReactTooltip id="count">
                              <span>Submit Count</span>
                            </ReactTooltip>
                            <ReactTooltip id="happyFace1">
                              <span>Submitted</span>
                            </ReactTooltip>
                            <ReactTooltip id="happyFace2">
                              <span>Not Submitted</span>
                            </ReactTooltip>
                            <ReactTooltip id="happyFace4">
                              <span>Upload</span>
                            </ReactTooltip>
                            <ReactTooltip id="happyFace5">
                              <span>History</span>
                            </ReactTooltip>
                            <div data-tip data-for={`comments${index}`}>
                              <img
                                src="/images/uploaded-details/img2.svg"
                                className="img-fluid cursor-pointer"
                                height={36}
                                width={36}
                                onClick={() =>
                                  handleModalComment(uploadDetailsObj)
                                }
                                alt=""
                              />
                              <ReactTooltip id={`comments${index}`}>
                                <span>
                                  {" "}
                                  Comment :{" "}
                                  {getValue(
                                    uploadDetailsObj,
                                    `recent_comment.comments`,
                                    ""
                                  )}
                                  ,{" "}
                                </span>
                              </ReactTooltip>
                            </div>

                            {getValue(uploadDetailsObj, `audit_status`, "") ===
                              "COMPLIED" ||
                            getValue(uploadDetailsObj, `audit_status`, "") ===
                              "NOT_APPLICABLE" ? (
                              <div
                                data-tip
                                data-for="happyFace4"
                                className="button-disabled"
                              >
                                <img
                                  src="/images/audit-review/upload.svg"
                                  className="img-fluid cursor-pointer"
                                  height={36}
                                  width={36}
                                  onClick={() =>
                                    getValue(mainParams, `listenable`, "") ===
                                    "1"
                                      ? handleModalUpload(uploadDetailsObj)
                                      : ""
                                  }
                                  alt=""
                                />
                              </div>
                            ) : (
                              <div data-tip data-for="happyFace4">
                                <img
                                  src="/images/audit-review/upload.svg"
                                  className="img-fluid cursor-pointer"
                                  height={36}
                                  width={36}
                                  onClick={() =>
                                    getValue(mainParams, `listenable`, "") ===
                                    "1"
                                      ? handleModalUpload(uploadDetailsObj)
                                      : ""
                                  }
                                  alt=""
                                />
                              </div>
                            )}
                            <NavLink
                              to={
                                // getValue(mainParams, `listenable`, "") === "1"?
                                `/checkpoint/details/history/${mainParams.id}/${
                                  mainParams.date
                                }/${mainParams.code}/${getValue(
                                  uploadDetailsObj,
                                  `checkpoint.id`,
                                  ""
                                )}/${getValue(
                                  mainParams,
                                  `listenable`,
                                  ""
                                ).trim()}/${getValue(
                                  mainParams,
                                  `audit_status`,
                                  ""
                                )}/${getValue(mainParams, `score`, "")}`
                                // : window.location.pathname
                              }
                            >
                              <div data-tip data-for="happyFace5">
                                <img
                                  src="/images/audit-review/timer.svg"
                                  className="img-fluid cursor-pointer"
                                  height={36}
                                  width={36}
                                  alt=""
                                />
                              </div>
                            </NavLink>
                          </div>

                          {/* {getValue(uploadDetailsObj, `upload_status`, "") !== "UPLOADED" && (
                            <div className="dropdown-wrapper mt-1 d-flex gap-2 unassign-file-selection">
                              <InputField
                                inputType="INPUT_REACT_SELECT"
                                name="document"
                                placeholder="Select the File"
                                options={unassignedDDList}
                                // onChange={(e:any) => handleDocumentSelect(e)}
                                // value={unassignedDDList.find((item:any) => item.id === documentRequest.document) || null} // type-safe matching
                                onChange={(e:any) => handleDocumentSelect(e, index)} // Pass index to update specific row
                                value={unassignedDDList.find((item: any) => item.id === documentRequest[index]) || null} // Access value by row index                
                                label={"document"}
                              />
  
                              <div>
                                <button 
                                  className="btn btn-primary p-2"
                                  style={{width: "50px"}}
                                  onClick={()=> handleUploadSubmitDocument(getValue(uploadDetailsObj, `id`, ""),index)}
                                  disabled={!documentRequest[index]} // Disable if no document is selected for the specific row
                                  >
                                  Save</button>
                              </div>
                            </div>                          
                          )} */}

                          <div className="d-flex align-items-start gap-2 justify-content-end">
                            {/* {getValue(uploadDetailsObj, `upload_status`, "") !==
                              "UPLOADED" &&
                              !getValue(
                                uploadDetailsObj,
                                `is_submitted`,
                                ""
                              ) && (
                                <div className="dropdown-wrapper mt-1 d-flex gap-2 unassign-file-selection">
                                  <InputField
                                    inputType="INPUT_REACT_SELECT"
                                    name="document"
                                    placeholder="Select the File"
                                    options={unassignedDDList}
                                    onChange={(e: any) =>
                                      handleDocumentSelect(e, index)
                                    }
                                    value={
                                      unassignedDDList.find(
                                        (item: any) =>
                                          item.id === documentRequest[index]
                                      ) || null
                                    }
                                    label={"document"}
                                    disabled={
                                      getValue(mainParams, `listenable`, "") ===
                                      "0"
                                        ? "disabled"
                                        : ""
                                    }
                                  />

                                  Show Save button only when a document is selected
                                  {documentRequest[index] && (
                                    <div>
                                      <button
                                        className="btn btn-primary p-2"
                                        style={{ width: "50px" }}
                                        onClick={() =>
                                          handleUploadSubmitDocument(
                                            getValue(
                                              uploadDetailsObj,
                                              `id`,
                                              ""
                                            ),
                                            index
                                          )
                                        }
                                        disabled={
                                          getValue(
                                            mainParams,
                                            `listenable`,
                                            ""
                                          ) === "0"
                                        }
                                      >
                                        Save
                                      </button>
                                    </div>
                                  )}
                                </div>
                              )} */}

                            {(getValue(
                              uploadDetailsObj,
                              `upload_status`,
                              ""
                            ) !== "UPLOADED" &&
                              !getValue(
                                uploadDetailsObj,
                                `is_submitted`,
                                ""
                              )) ||
                            (getValue(uploadDetailsObj, `upload_status`, "") !==
                              "UPLOADED" &&
                              getValue(uploadDetailsObj, `audit_status`, "") ===
                                "NON_COMPLIED") ? (
                              <div className="dropdown-wrapper mt-1 d-flex gap-2 unassign-file-selection">
                                <InputField
                                  inputType="INPUT_REACT_SELECT"
                                  name="document"
                                  placeholder="Select the File"
                                  options={unassignedDDList}
                                  onChange={(e: any) =>
                                    handleDocumentSelect(e, index)
                                  }
                                  value={
                                    unassignedDDList.find(
                                      (item: any) =>
                                        item.id === documentRequest[index]
                                    ) || null
                                  }
                                  label={"document"}
                                  disabled={
                                    getValue(mainParams, `listenable`, "") ===
                                    "0"
                                      ? "disabled"
                                      : ""
                                  }
                                />

                                {/* Show Save button only when a document is selected */}
                                {documentRequest[index] && (
                                  <div>
                                    <button
                                      className="btn btn-primary p-2"
                                      style={{ width: "50px" }}
                                      onClick={() =>
                                        handleUploadSubmitDocument(
                                          getValue(uploadDetailsObj, `id`, ""),
                                          index
                                        )
                                      }
                                      disabled={
                                        getValue(
                                          mainParams,
                                          `listenable`,
                                          ""
                                        ) === "0"
                                      }
                                    >
                                      Save
                                    </button>
                                  </div>
                                )}
                              </div>
                            ) : // )}
                            null}

                            {/* Show Submit button only when document is not selected or after save operation */}
                            {/* {!getValue(uploadDetailsObj, `is_submitted`, "") &&
                              !documentRequest[index] && (
                                <div className="d-flex justify-content-end">
                                  <button
                                    className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                                    onClick={() =>
                                      handleSubmitSingleTask(
                                        getValue(uploadDetailsObj, `id`, ""),
                                        getValue(
                                          uploadDetailsObj,
                                          `upload_status`,
                                          ""
                                        ),
                                        releaseAuditCycleId
                                      )
                                    }
                                    disabled={
                                      getValue(mainParams, `listenable`, "") ===
                                      "0"
                                    }
                                  >
                                    Submit
                                  </button>
                                </div>
                              )} */}

                            {((!getValue(
                              uploadDetailsObj,
                              `is_submitted`,
                              ""
                            ) &&
                              !documentRequest[index]) ||
                              getValue(uploadDetailsObj, `audit_status`, "") ===
                                "NON_COMPLIED") && (
                              <div className="d-flex justify-content-end">
                                <button
                                  className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                                  onClick={() =>
                                    handleSubmitSingleTask(
                                      getValue(uploadDetailsObj, `id`, ""),
                                      getValue(
                                        uploadDetailsObj,
                                        `upload_status`,
                                        ""
                                      ),
                                      releaseAuditCycleId
                                    )
                                  }
                                  disabled={
                                    getValue(mainParams, `listenable`, "") ===
                                    "0"
                                  }
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>

                          {/* {!getValue(uploadDetailsObj, `is_submitted`, "") && (
                            <div className="mt-1 d-flex justify-content-end">
                              <button
                                className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                                onClick={() => handleSubmitSingleTask(getValue(uploadDetailsObj, `id`, ""), getValue(uploadDetailsObj, `upload_status`, ""), releaseCycleId)}
                              >
                                Submit
                              </button>
                            </div>
                          )}
                           */}
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap mx-4">
                      {getValue(uploadDetailsObj, `documents.length`, 0) > 0 &&
                        getValue(uploadDetailsObj, `documents`, []).map(
                          (items: object, ind: number) => {
                            const isAuditCompleted =
                              auditStatus.is_audit_completed === true;
                            return (
                              <div key={ind}>
                                {getValue(items, `extension`, "") === ".pdf" ? (
                                  <div className="uploaded-details-wrapper__agreement d-flex align-items-center justify-content-between">
                                    <img
                                      src="/images/uploaded-details/pdf.svg"
                                      className="img-fluid cursor-pointer"
                                      alt=""
                                    />
                                    <p
                                      className="uploaded-details-wrapper__agreement-text text-truncate cursor-pointer"
                                      onClick={() =>
                                        handleS3FileDownloadOnClick(
                                          getValue(items, `key`, ""),
                                          getValue(items, `name`, "")
                                        )
                                      }
                                    >
                                      {getValue(items, `name`, "")}
                                    </p>
                                    {
                                      // !getValue(
                                      // 	uploadDetailsObj,
                                      // 	`is_submitted`,
                                      // 	false
                                      // ) && (
                                      getValue(
                                        uploadDetailsObj,
                                        `audit_status`,
                                        ""
                                      ) !== "SEND_BACK_TO_VENDOR" ? (
                                        <img
                                          onClick={() => {
                                            if (!isAuditCompleted) {
                                              if (
                                                getValue(
                                                  mainParams,
                                                  `listenable`,
                                                  ""
                                                ) === "1"
                                              ) {
                                                handleDeleteFile(
                                                  getValue(
                                                    uploadDetailsObj,
                                                    `id`,
                                                    ""
                                                  ),
                                                  getValue(items, `id`, "")
                                                );
                                              }
                                            }
                                          }}
                                          alt=""
                                          src="/images/uploaded-details/close-grey.svg"
                                          className="img-fluid cursor-pointer"
                                          style={
                                            isAuditCompleted
                                              ? {
                                                  cursor: "not-allowed",
                                                  opacity: 0.5,
                                                }
                                              : { cursor: "pointer" }
                                          }
                                        />
                                      ) : null
                                      // )
                                    }
                                  </div>
                                ) : (
                                  <div className="uploaded-details-wrapper__agreement d-flex align-items-center justify-content-between">
                                    <img
                                      src="/images/uploaded-details/word.svg"
                                      className="img-fluid cursor-pointer"
                                      alt=""
                                    />
                                    <p
                                      className="uploaded-details-wrapper__agreement-text text-truncate cursor-pointer"
                                      onClick={() =>
                                        handleS3FileDownloadOnClick(
                                          getValue(items, `key`, ""),
                                          getValue(items, `name`, "")
                                        )
                                      }
                                    >
                                      {getValue(items, `name`, "")}
                                    </p>
                                    {
                                      // !getValue(
                                      // 	uploadDetailsObj,
                                      // 	`is_submitted`,
                                      // 	false
                                      // ) && (
                                      getValue(
                                        uploadDetailsObj,
                                        `audit_status`,
                                        ""
                                      ) === "SEND_BACK_TO_VENDOR" ? null : (
                                        <img
                                          onClick={() => {
                                            if (!isAuditCompleted) {
                                              if (
                                                getValue(
                                                  mainParams,
                                                  `listenable`,
                                                  ""
                                                ) === "1"
                                              ) {
                                                handleDeleteFile(
                                                  getValue(
                                                    uploadDetailsObj,
                                                    `id`,
                                                    ""
                                                  ),
                                                  getValue(items, `id`, "")
                                                );
                                              }
                                            }
                                          }}
                                          src="/images/uploaded-details/close-grey.svg"
                                          className="img-fluid cursor-pointer"
                                          alt=""
                                          style={
                                            isAuditCompleted
                                              ? {
                                                  cursor: "not-allowed",
                                                  opacity: 0.5,
                                                }
                                              : { cursor: "pointer" }
                                          }
                                        />
                                      )
                                      // )
                                    }
                                  </div>
                                )}
                              </div>
                            );
                          }
                        )}
                    </div>
                  </div>
                );
              })
            ) : (
              <>
                {Object.keys(params).length !== 0 ? <Notfound /> : <Notfound />}
              </>
            )}
            <div className="pagination-wrapper mb-3">
              {totalCount > 100 ? (
                <PaginationPage
                  totalCount={totalCount}
                  limit={limit}
                  pageNumber={page_no}
                  handleChangePagination={handleChangePagination}
                  handleChangeLimit={handleChangeLimit}
                />
              ) : (
                <p className="show-rows-count mt-3 d-flex">
                  Total Count:&nbsp;&nbsp;{" "}
                  <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
                </p>
              )}
            </div>
            {isOpen && (
              <CommentsModal
                {...props}
                isOpen={isOpen}
                handleModal={handleModalCommentCancel}
                vendorInfo={vendorInfo}
                edit={true}
              />
            )}
            {isOpen1 && (
              <UploadModal
                {...props}
                isOpen={isOpen1}
                handleModal={handleModalUploadCancel}
                vendorInfo={vendorInfo}
                getData={getDataRefetch}
                mainParams={mainParams}
                getDashboardInfo={getDashboardInfo}
                handleModal2={handleModal2}
                selectedIndex={selectedIndex}
                checkUpload={checkUpload}
                handleSubmitTask={handleSubmitTask}
                releaseCycleIds={releaseCycleIds}
              />
            )}
            {isOpen2 && (
              <Modal
                isOpen={isOpen2}
                toggle={() => handleModal2()}
                centered
                size="lg"
              >
                <div className="d-flex justify-content-between my-3">
                  <div>
                    {/* <h3>Add Comments for Submission</h3> */}
                    <h3>
                      There is No Document attached! Do you still want to submit
                      ?
                    </h3>
                  </div>
                  <div>
                    <img
                      src="/images/close-black.svg"
                      className="img-fluid cursor-pointer"
                      onClick={handleModal2CloseIcon}
                    />
                  </div>
                </div>
                <ModalBody>
                  <div>
                    <label htmlFor="" className="mb-1">
                      Add Comment *
                    </label>
                    <InputField
                      inputType="TEXTAREA"
                      value={comments}
                      onChange={(e: any) => setComments(e.target.value)}
                      rows="10"
                      placeholder="Add Comment"
                    />
                  </div>
                  <div className="col-md-6">
                      <div className="d-flex align-items-center h-100">
                        <label className="me-2">Document Upload Not Applicable</label>
                        <div className="choicelist-wrapper custom-switch-wrapper height-40 d-flex align-items-center">
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={true}
                              disabled
                            />
                            <span className="slider round"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                </ModalBody>
                <div className="d-flex justify-content-end m-3">
                  <button
                    className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3"
                    onClick={() => handleModal2CloseIcon()}
                  >
                    Close
                  </button>
                  {/* {submitLoading ? (
                    <button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
                      Please wait...
                    </button>
                  ) : ( */}
                  <button
                    className="ascent-button ascent-button--header-buttons ascent-button--secondary"
                    onClick={handleSubmitTaskComment}
                  >
                    Submit for Audit Review
                  </button>
                  {/* )} */}
                </div>
              </Modal>
            )}
          </div>
          <br />
          <br />
          <div className="w-100">
            {/* {locations.length > 0 && (
              <img src="/images/footer.svg" className="img-fluid" />
            )} */}
          </div>
        </div>
        <DeleteModal
          isOpen={isDelete}
          handleModal={handleDelete}
          handleSubmit={handleDeleteFunction}
          deleteValue={""}
        />
      </div>
    </>
  );
};
